import { inject, Injectable } from '@angular/core';
import { catchError, finalize, firstValueFrom, interval, map, Observable, of, startWith, switchMap, takeWhile } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { PaymentMethod } from '../shared/interfaces/payment-method';
import { LinkInformation } from '../shared/interfaces/link-information';
import { Payment } from '../shared/interfaces/payment';
import { LinkStatus } from '../shared/enums/link-status';
import { PaymentType } from '../shared/enums/payment-types';
import { PaymentStatus } from '../shared/enums/payment-status';
import { generateUuid } from '../shared/utils/utils';
import { CacheService } from './cache.service';
import { PusherService } from './pusher.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  protected http: HttpClient = inject(HttpClient);

  private cache: CacheService = inject(CacheService);
  
  private pusherServ = inject(PusherService);
  

  getLinkInformation(linkId:string): Observable<LinkInformation>{

    const url = `https://paytek-africa.net:11901/api/get-store-link/${linkId}`;

    const linkCache = this.cache.get(url);

    if(linkCache){
      return of(linkCache as LinkInformation)  
    }

    return this.http.get<LinkInformation>(url).pipe(
      map(
        (data:any) => {

          console.log(data) 
          
          const rawData = data.data[0]
          
          const response = {
            ...rawData,
            status: rawData.status as LinkStatus,
          } as LinkInformation

          this.cache.put(url, response)

          return response
        }
      ),
      
    )
    
  }

  getAvailablePaymentServices(): Observable<PaymentMethod[]> {

    const url = `${environment.apiUrl}/get-payment-services`

    const avaliablePaymentServicesCache = this.cache.get(url)

    if(avaliablePaymentServicesCache){
      return of(avaliablePaymentServicesCache as PaymentMethod[])
    }
    
    return this.http.get<PaymentMethod>(url).pipe(
      map(
        (data: any) => {
          const response: PaymentMethod[] = data.data ?? []

          console.log(response)

          this.cache.put(url, response)

          return response
        }
      )
    );
  }

  makePayment(){

    // this.pusherServ.listen(
    //   'payment-push',
    //   (data: any)=>{
    //     console.log(`Data: ${data}`) 
    //   }
    // )
  }

  /**
   * 
   * @param paymentNumber 
   * @param amount 
   * @param store_number 
   * @param paymentMethod 
   * @param paymentType 
   * @returns 
   * 
   * @deprecated
   */
  createPayment(
    paymentNumber: string, 
    amount: number,
    store_number: number,
    paymentMethod: string, 
    paymentType: PaymentType, 
  ): Observable<Payment> {


    const partner_transaction_id = generateUuid();
    const link_id = localStorage.getItem('linkId') || '';
    
    return this.http.post<{data: Payment}>(
      `${environment.apiUrl}/imaliway/v2/payments`,
        {
          'client_account_number' : paymentNumber,
          'amount' : amount,
          'link_id' : link_id,
          'store_account_number' : store_number,
          'partner_transaction_id' : partner_transaction_id,
          'payment_method' : paymentMethod.toLowerCase(),
          'payment_type': paymentType
        }
    ).pipe(
      switchMap(
        ({data: initialPayment})=> {
          // console.log(initialPayment.transaction_id)

          // const transaction_id = initialPayment.transaction_id!;

          // console.log(transaction_id);

          return interval(10000).pipe(
            startWith(0),
            switchMap(
              ()=> this.http.get<{data: Payment}>(
                `${environment.apiUrl}/imaliway/v2/payments/status`,
                {
                  params: {
                    "partner_transaction_id": partner_transaction_id,
                    "payment_type" : paymentType
                  }
                }
              ).pipe(
                map(
                  ({ data: payment }) => payment
                ),
                catchError(err => {
                  console.error('Error fetching payment:', err);
                  return of(initialPayment); // Continue with the last known payment
                })
              )
            ),
            takeWhile( payment => payment.status === PaymentStatus.PENDING, true),
          )
        }
      )
    )
    
  }
  
}